import React from 'react';

export function useAutomationNodePopupState() {
    const [anchor, setAnchor] = React.useState<Element | null>(null);
    const handleOpen = React.useCallback<React.MouseEventHandler>(e => {
        setAnchor(e.currentTarget);
    }, []);
    const handleClose = React.useCallback(() => {
        setAnchor(null);
    }, []);
    return {
        anchor,
        onOpen: handleOpen,
        onClose: handleClose
    };
}
